import { AccountInfo, Connection, GetMultipleAccountsConfig, PublicKey } from '@solana/web3.js';
import { chunks } from '../utils/chunks';

export const getMultipleAccountsInfo = async (
  connection: Connection,
  keys: PublicKey[],
  options?: GetMultipleAccountsConfig,
) => {
  const accountToAccountInfoMap = new Map<string, AccountInfo<Buffer> | null>();
  await Promise.all(
    chunks(keys, 99).map(async (chunk) => {
      const accountInfos = await connection.getMultipleAccountsInfo(chunk, options);
      accountInfos.forEach((accountInfo, idx) => {
        accountToAccountInfoMap.set(chunk[idx].toString(), accountInfo);
      });

      return;
    }),
  );

  return accountToAccountInfoMap;
};
